import React from 'react';

import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import Select, { CustomSelectProps } from '../Select';

export type Option = {
  value: string | number;
  label: string;
  style?: React.CSSProperties;
  disabled?: boolean;
};

interface Props extends Omit<CustomSelectProps<string | number>, 'onSelected'> {
  control: Control<any>;
  name: string;
  label: string;
  variant?: 'standard' | 'outlined';
  disabled?: boolean;
  options: Option[];
  handleSelect?: (value: string | number) => void;
}

export default function ControlledSelect({
  control,
  name,
  label,
  options,
  variant = 'outlined',
  disabled = false,
  handleSelect,
  placeholder,
  displayEmpty = false,
  ...props
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <Select
            {...field}
            fullWidth
            variant={variant}
            disabled={disabled}
            onSelected={(value) => {
              handleSelect && handleSelect(value);
              field.onChange(value);
            }}
            label={label}
            options={options}
            error={fieldState.error}
            valueProp={field.value}
            placeholder={placeholder}
            displayEmpty={displayEmpty}
            ref={field.ref}
            {...props}
          />
        );
      }}
    />
  );
}
